import type { Stage } from '@/domain/creature/types';

export interface HouseStageInput {
  happiness: number;
  lightOn: boolean;
  poopCount: number;
  reducedMotion: boolean;
  sick: boolean;
  sleeping: boolean;
  stage: Stage;
  tantrum: boolean;
}

export interface HouseStageView {
  allowAmbientMotion: boolean;
  backdropTint: number;
  dimAlpha: number;
  mood: 'normal' | 'sad';
  poopMarkers: number;
  propTint: number;
  showSickAccent: boolean;
  showTantrumMarks: boolean;
}

export function getHouseStageView(input: HouseStageInput): HouseStageView {
  const inactiveStage = input.stage === 'egg' || input.stage === 'dead';
  const mood = input.happiness < 25 ? 'sad' : 'normal';
  const nightDim = input.lightOn ? 0 : 0.58;
  const moodDim = mood === 'sad' ? 0.1 : 0;

  return {
    allowAmbientMotion: !input.reducedMotion && !input.sleeping && !inactiveStage,
    backdropTint: input.lightOn ? 0xffffff : 0x9fb0d4,
    dimAlpha: Math.max(nightDim, moodDim),
    mood,
    poopMarkers: Math.max(0, Math.min(5, Math.floor(input.poopCount))),
    propTint: input.lightOn ? 0xffffff : 0x8fa0c8,
    showSickAccent: input.sick && input.stage !== 'dead',
    showTantrumMarks: input.tantrum && !inactiveStage,
  };
}
